module.exports = __webpack_public_path__ + "media/components/icons/SVG/search-400bc167b4612107d9477b1685765041.svg";